import { render, staticRenderFns } from "./AddBatchUserForm.vue?vue&type=template&id=a0f29542&"
import script from "./AddBatchUserForm.vue?vue&type=script&lang=js&"
export * from "./AddBatchUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports